<template>
    <v-app>
        <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
        <v-card class="grlCardInfo">
            <v-breadcrumbs :items="obtRuta" class="grlClase">
                <template v-slot:item="{ item }">
                    <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
                        {{ item.text.toUpperCase() }}
                    </v-breadcrumbs-item>
                </template>
            </v-breadcrumbs>
        </v-card>
        <!--IMAGEN Y TITULO DE LA PÁGINA-->
        <v-card>
            <v-img :src="imgTitle" class="grlCardImg">
                <div class="grlCardInfo">
                    <h1 class="my-auto hidden-sm-and-down">Ingeniero en Fruticultura</h1>
                </div>
            </v-img>
        </v-card>
        <!---->
        <div class="gralMargenes" id="gralEspaciado" style="text-align: justify">
            <hr />
            <h4 class="gralTitulosLic">Descripcion</h4>
            <div class="p-4">
                <p>
                    El Ingeniero Agrónomo Fruticultor puede conceptualizarse como el individuo cuya formación le permite dar
                    solución a los problemas tecnológicos, ecológicos y socioeconómicos a que se enfrenta la producción
                    vegetal y frutícola mediante la aplicación del método científico y con creatividad, sentido crítico y
                    espíritu de servicio.
                </p>
            </div>
            <h4 class="gralTitulosLic">Más Infromación</h4>
            <v-card class="m-4">
                <v-tabs>
                    <v-tabs-slider color="yellow"></v-tabs-slider>
                    <v-tab>Misión</v-tab>
                    <v-tab>Visión</v-tab>
                    <v-tab>Meta</v-tab>
                    <v-tab>Perfil de Ingreso</v-tab>
                    <v-tab>Perfil de Egreso</v-tab>
                    <v-tab>Plan de Estudios</v-tab>
                    <!--MISION-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <p>
                                El Programa Educativo tiene la Misión de formar profesionistas críticos, creativos,
                                innovadores, con conocimientos científicos y tecnológicos en el área de la Fruticultura,
                                comprometidos con la sociedad y el desarrollo sustentable, capaces de plantear, analizar y
                                solucionar problemas agropecuarios con creatividad y calidad, permitiéndoles insertarse con
                                éxito en un mercado laboral competitivo y globalizado.
                            </p>
                        </v-container>
                    </v-tab-item>
                    <!--VISION-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <p>
                                El Plan de Estudios de Ingeniero en Fruticultura aspira a ser uno de los mejores incidiendo
                                de manera importante en el desarrollo del sector agropecuario y con reconocimiento local,
                                nacional e internacional.
                            </p>
                        </v-container>
                    </v-tab-item>
                    <!--META-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <p>
                                El Ingeniero en Fruticultura egresado deberá poseer y mantener altos índices de
                                competitividad, superando estándares de calidad, al incluir la inocuidad como componente
                                básico, aumentando el volumen de producción agropecuaria, mejorando la eficiencia del
                                recurso humano, haciendo un uso más eficiente de los insumos y cumpliendo con los principios
                                de responsabilidad social y ambiental; lo anterior al utilizar los métodos, las técnicas y
                                los procedimientos resultado de su proceso de formación.
                            </p>
                        </v-container>
                    </v-tab-item>
                    <!--PERFIL DE INGRESO-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <span class="title">
                                <strong>PERFIL Y REQUISITOS DE INGRESO</strong>
                            </span>
                            <br>
                            <br>
                            <p>
                                El aspirante que desee ingresar a la carrera de ingeniero Agrónomo Fruticultor deberá contar
                                con:
                            </p>
                            <br>
                            <span class="subtitle"><strong>CONOCIMIENTOS</strong></span>
                            <hr>
                            <ul>
                                <li>Matemáticas.</li>
                                <li>Biológicas.</li>
                                <li>Físicas.</li>
                                <li>Químicas.</li>
                                <li>Ecológicas.</li>
                                <li>Económico – Administrativas.</li>
                                <li>Humanidades.</li>
                                <li>Informática.</li>
                                <li>Además de Técnicas de investigación documental.</li>
                            </ul>
                            <br>
                            <!-- NEWS TABLE 2 -->
                            <span class="subtitle"><strong>HABILIDADES Y DESTREZAS</strong></span>
                            <hr>
                            <ul>
                                <li>Habilidad para el trabajo en equipo.</li>
                                <li>Destreza para el trabajo bajo presión.</li>
                                <li>Capacidad para comprender fenómenos biológicos.</li>
                                <li>Habilidades para desarrollar labores de campo.</li>
                                <li>Capacidad de relacionarse con el sector agrícola.</li>
                                <li>Desempeñarse satisfactoriamente en el medio rural e identificarse con el mismo.</li>
                                <li>Hábitos de estudio.</li>
                                <li>Interés en mantener contacto con la naturaleza.</li>
                                <li>Atracción por las actividades que se desarrollan al aire libre.</li>
                                <li>Capacidad creativa para saber coordinar, articular, potenciar fortalezas, incluir
                                    divergencias y motivar la participación de los diferentes agentes sociales e
                                    institucionales.</li>
                                <li>Interés por la solución de los problemas de los sistemas de producción agrícola y
                                    pecuaria.</li>
                                <li>Visión empresarial.</li>
                            </ul>
                            <br>
                            <!-- NEWS TABLE 2 -->
                            <span class="subtitle"><strong>ACTITUDES</strong></span>
                            <hr>
                            <ul>
                                <li>Responsabilidad.</li>
                                <li>Disponibilidad.</li>
                                <li>Interés por poseer conocimientos amplios y diversos.</li>
                                <li>Actitudes honestas y éticas.</li>
                                <li>Vocación social y de apoyo.</li>
                                <li>Interés por el uso y manejo óptimo de los recursos agropecuarios y naturales.</li>
                                <li>Preocuparse y ocuparse por el mejoramiento social, cultural y económico de la sociedad.
                                </li>
                                <li>Iniciativa.</li>
                                <li>Respeto así mismo y a los demás.</li>
                                <li>Compromiso.</li>
                                <li>Lealtad.</li>
                                <li>Disciplina.</li>
                                <li>Creatividad.</li>
                                <li>Organización</li>
                                <li>Tolerancia</li>
                                <li>Disponibilidad.</li>
                            </ul>
                            <br>
                            <!-- NEWS TABLE 2 -->
                            <span class="subtitle"><strong>APTITUDES</strong></span>
                            <hr>
                            <ul>
                                <li>Utilizar eficientemente sistemas de cómputo y manejar bancos de información.</li>
                                <li>Relacionarse de manera fácil y sencilla con personas de nivel socio económico diverso.
                                </li>
                                <li>Manejar de manera correcta el instrumental científico, equipo y maquinaria.</li>
                                <li>Comunicarse de manera táctica y estratégica.</li>
                            </ul>
                        </v-container>
                    </v-tab-item>
                    <!--PERFIL DE EGRESO-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <span class="title">
                                <strong>PERFIL Y REQUISITOS DE EGRESO</strong>
                            </span>
                            <br>
                            <br>
                            <p>
                                El egresado de la licenciatura de Ingeniero Agrónomo Fruticultor es el profesional
                                capacitado para aplicar técnicas en la producción de frutales, manejo integrado de plagas y
                                enfermedades, diagnóstico e interpretación de análisis de suelo para eficientar la
                                producción frutícola, uso sustentable del agua disponible bajo los métodos y sistemas de
                                riego, analizar y aplicar los procesos fisiológicos ambientales que permitan maximizar el
                                potencial productivo, así como la transformación e industrialización de productos agrícolas,
                                la administración de procesos productivos de empresas agrícolas para la obtención de
                                producciones económicamente rentables e innovadoras de una manera racional y con respeto al
                                medio ambiente, además puede estar capacitado para desarrollar las siguientes competencias
                                profesionales:
                            </p>

                            <ol>
                                <li>Organizar y dirigir sistemas de producción mediante la aplicación de procesos, métodos y
                                    técnicas, para incrementar la producción frutícola, en el ámbito nacional e
                                    internacional, con actitud ética, creativa, solidaria con la sociedad, respeto al
                                    ambiente y con sentido sustentable.</li>
                                <li>Evaluar los procesos de conservación e industrialización de productos agropecuarios
                                    analizando su clasificación, conservación y transformación, para mantener y mejorar la
                                    calidad y generar valor agregado, responsabilidad y oportunidad, así como con respeto al
                                    ambiente y sentido sustentable.</li>
                                <li>Analizar y evaluar las tendencias de precios y mercados de los productos agropecuarios,
                                    para proponer alternativas que le permitan mejorar la competitividad, con apego a la
                                    normatividad nacional e internacional que coadyuve al desarrollo económico del país, con
                                    sentido social, objetividad y de pertinencia.</li>
                                <li>Aplicar el proceso de administración en las empresas agropecuarias y/o sector oficial,
                                    en el ámbito local, estatal, regional y nacional, empleando estrategias para optimizar
                                    recursos e incrementar la productividad, favoreciendo el desarrollo agropecuario del
                                    país, con honestidad, responsabilidad y eficiencia.</li>
                                <li>Diseñar y dirigir procesos de validación e interpretación de información relevante
                                    aplicando el método científico en los sistemas de producción, conservación
                                    industrialización y comercialización, con visión integradora, ética y cuidando al
                                    ambiente.</li>
                            </ol>
                            <br>
                            <br>
                            <!-- NEWS TABLE 2 -->
                            <span class="subtitle"><strong>REQUISITOS DE EGRESO</strong></span>
                            <hr>
                            <p>Se considera egreso, cuando el alumno obtenga los conocimientos, habilidades y actitudes
                                vinculadas a esta disciplina.</p>
                            <ul>
                                <li>Cubrir la totalidad de las asignaturas obligatorias y electivas del plan de estudios.
                                </li>
                                <li>Cubrir el total de 384 créditos repartidos de la siguiente manera: 92 del área básica,
                                    178 del área disciplinaria, 78 del área terminal, 12 del área integral (arte, cultura,
                                    deportes), 12 de experiencia recepcional (proyectos, tesis o tesina) y 12 del servicio
                                    social.</li>
                                <li>No tener adeudo económico, material, equipo de campo, laboratorio y biblioteca.</li>
                                <li>Aprobar los requisitos que se determinen para el idioma ingles.</li>
                                <li>Prácticas profesionales.</li>
                                <li>Servicio social.</li>
                                <li>Experiencia recepcional.</li>
                                <li>Actividades integrales.</li>
                                <li>Cubrir el requisito de lengua extranjera.</li>
                                <li>Titulación. El alumno deberá presentar como requisitos de titulación:
                                    <ul>
                                        <li>Certificado de Servicio Social.</li>
                                        <li>Documento que avale la realización de prácticas profesionales expedido por
                                            Organismo público, privado o social.</li>
                                        <li>Certificado de Estudios comprobatorio de promoción de las asignaturas en un
                                            total de 396 créditos.</li>
                                        <li>Elegir una de las modalidades de titulación aprobadas por la H. Junta Directiva
                                            de la Universidad Juárez del Estado de Durango.</li>
                                    </ul>
                                </li>
                            </ul>
                        </v-container>
                    </v-tab-item>
                    <!--PLAN DE ESTUDIOS-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <v-img :src="imgReticula"></v-img>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </div>
    </v-app>
</template>
<script>

export default {
    data: () => ({
        img: require('../../assets/img/logo_ujed.png'),
        imgReticula: require('../../assets/img/plan-estudios-fruticultura.jpg'),
        imgTitle: require('../../assets/img/banner-OE.jpg'),
        obtRuta: [
            {
                text: 'Inicio',
                disabled: false,
                ruta: '/',
            },
            {
                text: 'Oferta Educativa',
                disabled: true,
                ruta: '/',
            },
            {
                text: 'Licenciaturas',
                disabled: false,
                ruta: '/licenciaturas',
            },
            {
                text: '',
                disabled: true,
                ruta: '/licenciaturas',
            },
        ],
    }),
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
};
</script>
    